export const inputRule = [
  {
    required: true,
    message: "required",
    trigger: "blur",
  },
];

export const inputNumberRule = [
  {
    required: true,
    message: "required",
    trigger: "blur",
  },
  {
    trigger: "blur",
    validator: (rule, value, callback) => {
      if (value < 0) {
        callback(new Error("cannot-be-less-than-zero"));
      } else {
        callback();
      }
    },
  },
];

export const emailRule = [
  {
    required: true,
    message: "required",
    trigger: "blur",
  },
  {
    type: "email",
    message: "email format error",
    trigger: ["blur", "change"],
  },
];

export const phoneRule = [
  {
    required: true,
    message: "required",
    trigger: "blur",
  },
  {
    pattern:
      /^((\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3})|(\+852\s?\d{4}\s?\d{4})|(^1[3456789]\d{9})$/,
    message: "phone format error",
    trigger: ["blur", "change"],
  },
];

export const inputPositiveNumberRule = [
  {
    required: true,
    message: "required",
    trigger: "blur",
  },
  {
    trigger: "blur",
    validator: (rule, value, callback) => {
      if (value < 1) {
        callback(new Error("cannot be less than one"));
      } else {
        callback();
      }
    },
  },
];

export const inputRequiredPriceRule = [
  {
    required: true,
    message: "required",
    trigger: "blur",
  },
  {
    trigger: "blur",
    validator: (rule, value, callback) => {
      if (value < 0) {
        callback(new Error("cannot be less than zero"));
      } else if (!/^\d+(\.\d{1,2})?$/g.test(value)) {
        callback(new Error("up to two decimal places"));
      } else {
        callback();
      }
    },
  },
];

export const inputPriceRule = [
  {
    trigger: "blur",
    validator: (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback();
      }
      if (value < 0) {
        callback(new Error("cannot be less than zero"));
      } else if (!/^\d+(\.\d{1,2})?$/g.test(value)) {
        callback(new Error("up to two decimal places"));
      } else {
        callback();
      }
    },
  },
];

export const selectRule = [
  {
    required: true,
    message: "required",
    trigger: ["change"],
  },
];

export const dateRule = [
  {
    type: "date",
    required: true,
    message: "required",
    trigger: "change",
  },
];
